import User from '../constants/user'

export const SET_USER = 'paye-bo/user/SET_USER'
export const RELOAD_IMG = 'paye-bo/user/RELOAD_IMAGE'

const LOCALHOST_3000 = 'localhost:3000'
const OMDD_LOCAL_3000 = 'omdd.local:3000'
export default function user(
  state = {
    user: User.NULL,
    testmode: window.location.host === LOCALHOST_3000 || window.location.host === OMDD_LOCAL_3000,
    reloadImg: 1,
  },

  action
) {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.value }
    case RELOAD_IMG:
      return { ...state, reloadImg: action.value }
    default:
      return state
  }
}
